import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AuthenticatedSidebar from "../components/AuthenticatedSidebar";
import { P2PNavigationProvider } from "../context/P2PNavigationContext";
import ModuleTermsAcceptanceGate from "../components/terms/ModuleTermsAcceptanceGate";
import LogisticsProviderProfileGate from "../components/LogisticsProviderProfileGate";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/theme.scss";
import "../assets/styles/common-header-footer.scss";
import "../assets/styles/authenticated-layout.scss";

/** App dashboard sidebar hidden; page uses its own section nav (e.g. logistics profile edit). */
const HIDE_APP_SIDEBAR_PATH_PREFIXES = ["/logistics-profile/edit"];

export default function AuthenticatedLayout() {
  const { pathname } = useLocation();
  const hideAppSidebar = HIDE_APP_SIDEBAR_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

  return (
    <div className="d-flex flex-column min-vh-100 bg-white text-dark">
      <Header />

      <div className="authenticated-shell-wrap">
        <div
          className={`authenticated-shell${hideAppSidebar ? " authenticated-shell--no-sidebar" : ""}`}
        >
          {!hideAppSidebar ? <AuthenticatedSidebar /> : null}
          <main className="authenticated-shell__main flex-grow-1">
            <P2PNavigationProvider>
              <ModuleTermsAcceptanceGate>
                <LogisticsProviderProfileGate>
                  <Outlet />
                </LogisticsProviderProfileGate>
              </ModuleTermsAcceptanceGate>
            </P2PNavigationProvider>
          </main>
        </div>

        <Footer />
      </div>
    </div>
  );
}


